import { render, staticRenderFns } from "./SmatIot.vue?vue&type=template&id=56ff6be1&"
import script from "./SmatIot.vue?vue&type=script&lang=js&"
export * from "./SmatIot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports